var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.955 19.955C17.8452 22.0647 14.9837 23.25 12 23.25C9.01632 23.25 6.15483 22.0647 4.04505 19.955C1.93526 17.8452 0.75 14.9837 0.75 12C0.75 9.01632 1.93526 6.15483 4.04505 4.04505C6.15483 1.93526 9.01632 0.75 12 0.75C14.9837 0.75 17.8452 1.93526 19.955 4.04505C22.0647 6.15483 23.25 9.01632 23.25 12C23.25 14.9837 22.0647 17.8452 19.955 19.955Z",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28039 15.189V8.21052C9.27898 8.09138 9.30964 7.97404 9.36915 7.8708C9.42865 7.76757 9.51482 7.68223 9.61862 7.62372C9.72243 7.56521 9.84005 7.53569 9.95918 7.53824C10.0783 7.54079 10.1946 7.57532 10.2958 7.63822L16.3327 11.1274C16.4322 11.1862 16.5147 11.2699 16.572 11.3703C16.6293 11.4706 16.6594 11.5842 16.6594 11.6998C16.6594 11.8153 16.6293 11.9289 16.572 12.0293C16.5147 12.1296 16.4322 12.2133 16.3327 12.2721L10.2958 15.8536C10.1878 15.923 10.0621 15.9596 9.93373 15.959C9.8054 15.9585 9.67998 15.9208 9.57261 15.8505C9.46523 15.7802 9.3805 15.6803 9.32865 15.563C9.27679 15.4456 9.26003 15.3157 9.28039 15.189Z",
    stroke: "#393939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.0aae1930e550008dc65363c2fea06b72.svg";
export { ForwardRef as ReactComponent };